<template>
  <v-card :flat="!(items.length < 7)">
    <v-card-title primary-title>
      <slot name="Title"> </slot>
    </v-card-title>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr class="teal darken-3">
            <th
              v-for="(item, index) in header"
              :key="'coll-' + index"
              class="text-left white--text"
            >
              <Strong> {{ item.title }}</Strong>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="!items.length && !loading">
            <td :colspan="header.length">
              <p class="text-center text-secondary">{{ EmptyMessage }}</p>
            </td>
          </tr>
          <tr v-if="loading">
            <td :colspan="header.length">
              <v-progress-linear height="6" indeterminate> </v-progress-linear>
            </td>
          </tr>

          <tr v-for="(item, row) in items" :key="'row-' + row">
            <td
              v-for="(item2, coll) in header.length"
              :key="'cell-' + row + ',' + coll"
            >
              <slot :name="'coll.' + header[coll].title" :row="item">
                {{ item[header[coll].value] }}
              </slot>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <v-divider height="10"></v-divider> -->
    <v-card-actions class="teal darken-2 white--text">
      <slot name="footer"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    EmptyMessage: { type: String, default: "No date" },
    header: { type: Array, required: true },
    items: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
};
</script>
